"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageQueries = exports.mediaQueries = exports.font = exports.widths = void 0;
var widths = {
  desktopWidth: 1024,
  footerHeight: 200,
  headerHeight: 56,
  containerWidth: 696,
  bigContainerWidth: 1176,
  column: 96,
  gutter: 24,
  bookingContainerWidth: 936,
  base: 8,
  tinyMobile: 350
};
exports.widths = widths;
var font = {
  montse: 'Montserrat, Helvetica, Arial, sans-serif',
  regular: 400,
  medium: 500,
  semi: 600
};
exports.font = font;
var mediaQueries = {
  desktop: "@media (min-width: ".concat(widths.desktopWidth, "px)"),
  notDesktop: "@media not all and (min-width: ".concat(widths.desktopWidth, "px)"),
  tinyMobile: "@media (max-width: ".concat(widths.tinyMobile, "px)")
};
exports.mediaQueries = mediaQueries;
var imageQueries = {
  desktop: "(min-width: ".concat(widths.desktopWidth, "px)")
};
exports.imageQueries = imageQueries;